import React from 'react'
import SignIn from '../../components/SignIn'

function SingIn() {
  return (
    <h1><SignIn/></h1>
  )
}

export default SingIn